import { Organisation } from '~organisations/domain';

import logo from './images/logo.svg';

const mycarConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default mycarConfig;
